import { ThemeModeComponentSwitcher } from '@apps-common/components/common/ThemeModeComponentSwitcher'

interface IProps {
  containerClasses?: string
  classes?: string
}

export const MyMonitoringLogoColor: React.FC<IProps> = ({ containerClasses, classes }) => (
  <div className={containerClasses}>
    <ThemeModeComponentSwitcher
      lightComponent={<img src='/assets/logos/mymon_dark_logo.png' alt='MyMonitoring Logo' className={classes} />}
      darkComponent={<img src='/assets/logos/mymon_light_logo.png' alt='MyMonitoring Logo' className={classes} />}
    />
  </div>
)
